import * as React from "react";
const SvgSlack = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E01E5A",
  d: "M6.074 14.87c0 1.127-.91 2.037-2.037 2.037A2.035 2.035 0 0 1 2 14.87c0-1.126.91-2.037 2.037-2.037h2.037zm1.019 0c0-1.126.91-2.037 2.037-2.037s2.037.91 2.037 2.037v5.093c0 1.127-.91 2.037-2.037 2.037a2.035 2.035 0 0 1-2.037-2.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36C5F0",
  d: "M9.133 6.067A2.03 2.03 0 0 1 7.1 4.034C7.1 2.909 8.01 2 9.133 2c1.125 0 2.034.909 2.034 2.034v2.033zm0 1.032c1.125 0 2.034.91 2.034 2.034a2.03 2.03 0 0 1-2.034 2.034h-5.1A2.03 2.03 0 0 1 2 9.133C2 8.008 2.909 7.1 4.034 7.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2EB67D",
  d: "M17.926 9.133c0-1.125.91-2.034 2.037-2.034a2.033 2.033 0 1 1 0 4.068h-2.037zm-1.019 0c0 1.125-.91 2.034-2.037 2.034a2.033 2.033 0 0 1-2.037-2.034v-5.1c0-1.124.91-2.033 2.037-2.033s2.037.909 2.037 2.034z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECB22E",
  d: "M14.867 17.926c1.125 0 2.034.91 2.034 2.037a2.033 2.033 0 1 1-4.068 0v-2.037zm0-1.019a2.033 2.033 0 0 1-2.034-2.037c0-1.126.91-2.037 2.034-2.037h5.1c1.124 0 2.033.91 2.033 2.037a2.033 2.033 0 0 1-2.034 2.037z"
}));
export default SvgSlack;
//# sourceMappingURL=Slack.js.map